import { useEffect } from 'react'

import { showError } from '../../../lib/toast'

// Передача relevance counts обратно в MainContent
export function useRelevanceCountsEffect(
  relevanceCounts: { relevant: number; nonRelevant: number; notAnalyzed: number; total: number },
  onRelevanceCountsChange?: (counts: { relevant: number; nonRelevant: number; notAnalyzed: number; total: number }) => void
) {
  useEffect(() => {
    if (onRelevanceCountsChange) {
      onRelevanceCountsChange(relevanceCounts)
    }
  }, [relevanceCounts, onRelevanceCountsChange])
}

// Сброс lazy loading при изменении фильтров
export function useLazyLoadingResetEffect(
  activeStatus: string | null,
  searchQuery: string,
  relevanceFilter: string,
  sortedFilteredJobsLength: number,
  setDisplayedJobsCount: React.Dispatch<React.SetStateAction<number>>,
  setAllJobsLoaded: React.Dispatch<React.SetStateAction<boolean>>
) {
  useEffect(() => {
    setDisplayedJobsCount(20)
    setAllJobsLoaded(sortedFilteredJobsLength <= 20)
  }, [activeStatus, searchQuery, relevanceFilter, sortedFilteredJobsLength, setDisplayedJobsCount, setAllJobsLoaded])
}

// Show error in toast
export function useErrorToastEffect(
  error: string | null
) {
  useEffect(() => {
    if (error) {
      showError(error)
    }
  }, [error])
}
